import React from 'react';
import MuiStepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import {makeStyles} from "@material-ui/styles";


const useStyle = makeStyles(() => ({
    stepperRoot: {
        backgroundColor: "inherit",
        padding: '16px'
    },
    stepLabel: {
        fontSize: '0.875rem',
        fontWeight: 500,
        lineHeight:'16px',
        textAlign: 'center'
    }
}))

const getStepperLabelKey = (id) => `${id}-stepper-label`

export const Stepper = ({activeStep, stepNames, errorSteps=[]}) => {
    const classes = useStyle()

    return <MuiStepper activeStep={activeStep}
                    classes={{root: classes.stepperRoot}}
    >
            {stepNames.map((label, index) => (
                <Step
                    key={getStepperLabelKey(index)}>
                    <StepLabel classes={{label: classes.stepLabel}} error={errorSteps[index]}>{label}</StepLabel>
                </Step>
            ))}
        </MuiStepper>
}